<template>
  <div class="pad30" v-if="loaded">
    <h2 class="f18 fb normal gray_2">口碑视频管理</h2>
    <div class="box20"></div>
    <div class="flex flex-wrap flex1 items-center mar20-b">
      <div>
        <el-input class="w150 mar20_r" placeholder="请输入商品关键字" v-model.trim="name"></el-input>
      </div>
      <el-button @click="getList">查询</el-button>

      <el-button type="primary" class="mar-20-l" @click="chooseGoods">引入商品</el-button>

      <el-button v-if="selfOperatedShop" type="primary" class="mar-20-l" @click="bindVlogId(weChatChannelOpenId)">绑定视频号</el-button>
    </div>
    <el-table :data="dataList" @selection-change="kbVlogSelect" row-key="targetId" style="width: 100%">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column show-overflow-tooltip prop="name" label="商品名称" />
      <el-table-column prop="detailAmount" label="视频数量" />
      <el-table-column label="操作" width="240">
        <template slot-scope="scope">
          <el-button @click="editActivity(scope.row)">上传视频</el-button>
          <el-button class="mar15-l" @click="deleteInfo(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="flex items-center mar20-t">
      <el-button type="primary" :disabled="this.multipleSelection.length == 0" @click="deleteList">批量删除 </el-button>
      <div class="gray9 flex-auto mar-20-l">共 {{ pageTotal }} 条记录 第 {{ pageNum }} / {{ totalPage }} 页</div>
      <el-pagination
        layout="prev, pager, next, sizes, jumper"
        background
        hide-on-single-page
        :page-size.sync="pageSize"
        :page-count="totalPage"
        :current-page.sync="pageNum"
        :page-sizes="[10, 20, 30]"
        @size-change="sizeChange"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="选择商品"
      :visible.sync="chooseGoodVisible"
      :close-on-click-modal="false"
      width="945px"
      top="80px"
      :show-close="false"
      custom-class="chooseGoodPop"
    >
      <div>
        <div class="clear ps_search_wrap">
          <span class="float-left pad15_r lin_30 inlineblock gray_3">货品名称</span>
          <div class="ps_search float-left">
            <el-input type="text" placeholder="请输入货品名称" v-model="searchGoods.name"> </el-input>
          </div>
          <div class="float-left client_pop_query" @click="getPriceGoodsList(1)">搜索</div>
        </div>
        <div class="box20"></div>
        <div class="clear appoint_goods_list">
          <div class="float-left client_list_all">
            <p class="gray_3">本店货品</p>
            <div class="client_list_wrap">
              <ul class="clear">
                <li v-for="(item, index) in goodsDataList" :key="index" @click="goodsDialogSelect(item)" :class="[item.activityUsed ? 'opacity3' : '']">
                  <img class="float-left appoint_good_img" v-if="item.mainPicUrl" :src="item.mainPicUrl" alt="" />
                  <img class="float-left appoint_good_img" v-else src="@/assets/images/goods_small.jpg" alt="" />
                  <div class="float-left appoint_good_main">
                    <p class="ellipsis_two f14 gray_3" :title="item.name">{{ item.spuName }}</p>
                    <p v-if="item.activityUsed" class="f16 mar10-t">已添加</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="float-right client_list_me">
            <p class="gray_3">已选货品</p>
            <div class="client_list_wrap">
              <ul class="clear">
                <li v-for="(item, index) in goodsSelectList" :key="index">
                  <i class="iconfont icon-shibai fb" @click="removeSelectGoods(item)"></i>
                  <img class="float-left appoint_good_img" v-if="item.mainPicUrl" :src="item.mainPicUrl" alt="" />
                  <img class="float-left appoint_good_img" v-else src="@/assets/images/goods_small.jpg" alt="" />
                  <div class="float-left appoint_good_main">
                    <p class="ellipsis_two f14 gray_3" :title="item.name">{{ item.spuName }}</p>
                    <p class="f12 gray_6"></p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="box20"></div>
      </div>
      <el-pagination
        background
        @size-change="handleSizeChange2"
        @current-change="handleCurrentChange2"
        :current-page="currentPage2"
        :page-sizes="[10, 20, 30]"
        :page-size="pageSize2"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount2"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goodsDialogConfirm">确 认</el-button>
        <el-button @click="goodsDialogClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
  <div style="min-height: 900px" v-else></div>
</template>

<script>
import { mapState } from "vuex";
import requestApi from "@/utils/requestApi";
import { Loading } from "element-ui";
import requestSC from "@/utils/requestSC";

export default {
  data() {
    return {
      loaded: false,
      env: process.env,
      dataList: [],
      multipleSelection: [],
      // 搜索
      name: "",
      pageSize: 10,
      pageNum: 1,
      totalPage: 10,
      pageTotal: 0,
      chooseGoodVisible: false,
      searchGoods: {
        name: "",
        axis: "",
        shopId: "",
        groupId: "",
        pageNum: 1,
        pageSize: 10,
        status: "",
      },
      goodsDataList: [], // 商品 接口获取
      // 分页
      currentPage: 1,
      totalCount: 0,
      pageSize1: 6,
      currentPage1: 1,
      totalCount1: 0,
      pageSize2: 10,
      currentPage2: 1,
      totalCount2: 0,
      goodsPageList: [], // 商品 分页展示
      goodsPageTotalList: [], // 商品 分页总数据
      goodsSelectList: [], // 商品 选择
      selfOperatedShop: false, // 是否直营
      weChatChannelOpenId: "", // 视频号ID
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    requestSC.get("rest/mj/goods/seq/shopConfig").then((res) => {
      this.selfOperatedShop = res.data.selfOperatedShop;
      this.getList();
    });

    // 获取 绑定的视频号ID
    this.getVlogId();
  },
  methods: {
    openWindow(title, url) {
      if (self != top) {
        window.parent.postMessage(
          {
            fn: "open",
            data: {
              url: url,
              title: title,
              target: 0,
            },
          },
          "*"
        );
      } else {
        window.open(url);
      }
    },

    editActivity(row) {
      let id = row.id;
      window.location.href = `${process.env.VUE_APP_APP}v/mj/kbVlog/update?appid=1&isShowTitle=1&id=` + id;
    },
    getList() {
      let loadingInstance1 = Loading.service({ fullscreen: true });
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}sctrading/activity/commonactivity/mj/selPage`, {
          spuNameLike: this.name,
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          type: "KB",
        })
        .then((res) => {
          this.pageTotal = res.data.total;
          this.dataList = res.data.list;
          this.totalPage = res.data.pages;
          this.loaded = true;
          loadingInstance1.close();
        });
    },
    // 修改每页显示个数
    sizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageNum = 1;
      this.getList();
    },

    // 修改页码
    currentChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },

    kbVlogSelect(val) {
      console.log("val", val);
      this.multipleSelection = val || [];
    },
    deleteInfo(item) {
      let idList = [];
      idList.push(item.id);
      this.$confirm("您确认要删除选择的口碑视频吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        requestApi
          .post(`${process.env.VUE_APP_APITAAS}sctrading/activity/commonactivity/mj/delBatch`, {
            idList: idList,
          })
          .then((res) => {
            if (res.code == "0") {
              this.$message.success("删除成功");
              this.pageNum = 1;
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
      });
    },
    deleteList() {
      if (this.multipleSelection.length === 0) {
        this.$message.info("请选择商品");
        return;
      }
      let idList = [];
      let nameList = [];
      this.multipleSelection.forEach(function (item) {
        idList.push(item.id);
        nameList.push(item.name);
      });
      this.$confirm("您确认要删除选择的口碑视频吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        requestApi
          .post(`${process.env.VUE_APP_APITAAS}sctrading/activity/commonactivity/mj/delBatch`, {
            idList: idList,
          })
          .then((res) => {
            if (res.code == "0") {
              this.$message.success("删除成功");
              this.pageNum = 1;
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
      });
    },
    // 1搜索  2选择货品
    getPriceGoodsList(type) {
      const { searchGoods } = this;
      searchGoods.pageNum = this.currentPage2;
      searchGoods.pageSize = this.pageSize2;
      if (type === 1) {
        // 搜索
        searchGoods.pageNum = 1;
      }
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}sctrading/goodsspu/mj/selList`, {
          status: 5,
          queryType: "KB",
          name: searchGoods.name,
          pageNum: searchGoods.pageNum,
          pageSize: searchGoods.pageSize,
        })
        .then((data) => {
          const newData = data || {};
          this.goodsDataList = newData.data.list || [];
          this.totalCount2 = newData.data.total || 0;
          if (type === 2) {
            if (this.goodsDataList.length === 0) {
              this.$message.error("无货品数据,请添加货品");
              return;
            }
            this.chooseGoodVisible = true;
          }
        });
    },
    // 点击添加商品
    chooseGoods() {
      this.goodsSelectList = [];
      this.getPriceGoodsList(2);
    },
    // 商品选择事件
    goodsDialogSelect(goods) {
      if (goods.activityUsed) {
        return;
      }
      this.$set(goods, "isActive", !goods.isActive);
      const find = this.goodsSelectList.find((selectGoods) => selectGoods.id === goods.id);
      if (!find) {
        const assign = Object.assign({}, goods);
        this.goodsSelectList.push(assign);
        this.handGoodsPrice(this.goodsSelectList);
      }
    },
    // 删除已选择的商品
    removeSelectGoods(goods) {
      this.goodsSelectList.splice(
        this.goodsSelectList.findIndex((item) => item.id === goods.id),
        1
      );
    },
    goodsDialogConfirm() {
      this.goodsPageTotalList = Array.from(this.goodsSelectList);
      this.localGoodsPageList();
      this.goodsDialogClose();
      this.addActivity();
    },
    // 删除商品
    removeGoods(goods) {
      this.goodsPageTotalList.splice(
        this.goodsPageTotalList.findIndex((item) => item.id === goods.id),
        1
      );
      this.localGoodsPageList();
    },
    goodsDialogClose() {
      this.searchGoods = {};
      this.currentPage2 = 1;
      this.chooseGoodVisible = false;
    },
    // 本地分页
    localGoodsPageList() {
      const array = this.goodsPageTotalList || [];
      const pageNo = this.currentPage;
      const { pageSize } = this;
      const offset = (pageNo - 1) * pageSize;
      this.goodsPageList = offset + pageSize >= array.length ? array.slice(offset, array.length) : array.slice(offset, offset + pageSize);
      this.totalCount = array.length;
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.getPriceGoodsList();
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val;
      this.getPriceGoodsList();
    },
    handGoodsPrice(memberPriceList) {
      // 格式化小数位数
      if (memberPriceList) {
        memberPriceList.forEach((item) => {
          const formatPrice = this.formatPrice(item.price, item.goodsPriceDigit);
          this.$set(item, "price", formatPrice);
        });
      }
    },
    // num 输入的数字 scale精确小数位数 negative true负数
    formatPrice(nums, scale, negative) {
      let value = `${nums}`;
      if (negative === true) {
        value = value.replace(/[^\-\d.]/g, "");
      } else {
        value = value.replace(/[^\d.]/g, "");
      }
      value = value.replace(/\\-{2,}/g, "-");
      value = value.replace(/\.{2,}/g, ".");
      value = value.replace(".", "$#$");
      value = value.replace(/\./g, "");
      value = value.replace("$#$", ".");
      const reg = new RegExp(`^(-)?(\\d{1,8})\\.(\\d{0,${scale}}).*$`);
      value = value.replace(reg, "$1$2.$3");
      console.info(value);
      if (value.indexOf(".") < 0 && value !== "" && value !== "-") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value);
      }
      return value;
    },
    addActivity() {
      console.log(this.goodsSelectList);
      if (this.goodsSelectList.length <= 0) {
        return;
      }
      let reqBatchList = [];
      this.goodsSelectList.forEach((item) => {
        let reqObj = {};
        reqObj.name = item.spuName;
        reqObj.spuId = item.id;
        reqBatchList.push(reqObj);
      });
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}sctrading/activity/commonactivity/mj/addBatch`, {
          type: "KB",
          reqBatchList: reqBatchList,
        })
        .then((res) => {
          if (res.code == "0") {
            this.$message.success("添加成功");
            this.pageNum = 1;
            this.getList();
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 绑定视频号
    bindVlogId(vlogId) {
      this.$prompt("请输入视频号ID", vlogId ? "编辑" : "添加", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "请输入视频号ID",
        inputValue: vlogId ? vlogId : "",
      })
        .then(({ value }) => {
          requestApi
            .post(`${process.env.VUE_APP_APITAAS}sctrading/activity/commonactivity/mj/bindVlogId`, {
              weChatChannelOpenId: value.trim(),
            })
            .then((res) => {
              if (res.code == "0") {
                this.$message.success("编辑成功");
                this.weChatChannelOpenId = value.trim();
              } else {
                this.$message.error(res.msg);
              }
            });
        })
        .catch(() => {});
    },
    getVlogId() {
      requestApi.post(`${process.env.VUE_APP_APITAAS}sctrading/activity/commonactivity/mj/bindVlogId/query`, {}).then((res) => {
        if (res.data && res.data.weChatChannelOpenId) {
          this.weChatChannelOpenId = res.data.weChatChannelOpenId;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "list.scss";
</style>

<style>
.el-button--primary:hover,
.el-button--primary:focus {
  background: #0095f1;
  border-color: #0095f1;
  color: #ffffff;
}

.el-button--primary:active {
  background: #0095f1;
  border-color: #0095f1;
  color: #ffffff;
  outline: none;
}

.el-button--primary {
  color: #ffffff;
  background-color: #0095f1;
  border-color: #0095f1;
}

.el-button:active {
  color: #ffffff;
  outline: none;
}

.el-message-box .el-button:active {
  color: #ffffff;
  border-color: #0095f1;
  background-color: #0095f1;
}

.el-message-box .el-button:hover,
.el-message-box .el-button:focus {
  color: #ffffff;
  border-color: #0095f1;
  background-color: #0095f1;
}

.el-button--primary.is-disabled,
.el-button--primary.is-disabled:hover,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:active {
  color: #ffffff;
  border-color: #0095f1;
  background-color: #0095f1;
}

.el-select-dropdown__item.selected {
  color: #0095f1;
  font-weight: bold;
}
.ps_main_head {
  color: #999;
  background-color: #f8f8f8;
  padding-left: 30px;
  height: 40px;
  line-height: 40px;
  margin-bottom: 20px;
  font-size: 12px;
}
.opacity3 {
  opacity: 0.3;
  cursor: not-allowed;
}
</style>
